import { Card, Group, Skeleton, Stack, useMantineTheme } from '@mantine/core';
import { memo } from 'react';

export const ChartSkeleton = memo(() => {
	const theme = useMantineTheme();

	return (
		<Card withBorder style={{ borderRadius: theme.radius.md }}>
			<Stack spacing="md">
				<Group position="apart">
					<Skeleton height={24} width={120} />
					<Group spacing="sm">
						<Skeleton height={36} width={100} />
						<Skeleton height={36} width={150} />
					</Group>
				</Group>
				<Skeleton height={300} width="100%" />
			</Stack>
		</Card>
	);
});
